import { state } from '../state'
import type { MontillaContext } from '../types/destination'

/**
 * Waits for the montilla to be ready.
 */
export async function ready(): Promise<void> {
  await state.eventBus.ready()
  return void 0
}

/**
 * Returns a snapshot of the current metadata.
 * Returns a Faro-compatible shape for backward compatibility.
 */
export async function getMetas(): Promise<Record<string, unknown> | null> {
  try {
    await state.eventBus.ready()
    const context = state.context

    if (!context) {
      return null
    }

    return cloneMeta(mapContextToMetas(context))
  } catch {
    return null
  }
}

/**
 * Returns the raw MontillaContext.
 */
export async function getContext(): Promise<MontillaContext | null> {
  try {
    await state.eventBus.ready()
    return state.context ? cloneMeta(state.context) : null
  } catch {
    return null
  }
}

/**
 * Maps MontillaContext to a Faro-metas-compatible shape for backward compat.
 */
function mapContextToMetas(context: MontillaContext): Record<string, unknown> {
  return {
    app: context.app,
    page: context.page,
    session: context.session,
    user: {
      hash: context.user.hash,
      id: context.user.id,
      email: context.user.email,
      attributes: context.user.traits,
    },
    sdk: context.sdk,
    view: context.view,
  }
}

function cloneMeta<T>(value: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(value)
  }
  return JSON.parse(JSON.stringify(value)) as T
}
